module.exports = __webpack_public_path__ + "img/mag (1).47a64eb1.png";